export default __webpack_public_path__ + "img/requisition-center.7fe65f.svg";